import { useQueryClient } from '@tanstack/react-query'

import { ApiStudentRequest, request } from '../utils'
import { useAuthMutation } from './auth'
import type { RawApplicationResponse } from './useGetApplication'

type CopyDocumentsProps = {
  targetApplicationId: string
}

type CopyDocumentsParams = {
  sourceApplicationId: string
}

export function useCopyDocuments(props: CopyDocumentsProps) {
  const queryClient = useQueryClient()

  const { isPending, mutate, mutateAsync } = useAuthMutation(
    async (params: CopyDocumentsParams) => {
      return request<RawApplicationResponse>(
        new ApiStudentRequest(`/applications/${props.targetApplicationId}/copy-documents`, {
          method: 'POST',
          body: {
            data: {
              type: 'application',
              attributes: {
                sourceApplicationId: params.sourceApplicationId,
              },
            },
          },
        }),
        {
          isExpectedResponse: (res): res is RawApplicationResponse => res as boolean,
        },
      )
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['applications', props.targetApplicationId] })
      },
    },
  )

  return {
    isCopyingDocuments: isPending,
    copyDocuments: mutate,
    copyDocumentsAsync: mutateAsync,
  }
}
